import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router";
import { isEmpty, get } from "lodash-es";
import { useQuery } from "react-query";
import { useOrganizationDetails } from "hooks/api/fulfillment/organization";
import { fetchEventSubscriptionsIndex } from "../../../../api/accounts/event_subscriptions";

import EventSubscriptionsTable from "./EventSubscriptionsTable";

const OrganizationEventSubscriptionsPage = () => {
  const history = useHistory();
  const params = useParams();

  const { fetchOrganizationDetails, organizationDetails } = useOrganizationDetails();

  const organizationID = get(params, "organization_id");
  const query = {
    per_page: 200,
    organization_id: organizationID,
  };

  const EventSubscriptionIndex = useQuery(
    ["EventSubscriptionIndex", query],
    () => fetchEventSubscriptionsIndex(query),
    { enabled: !isEmpty(query) }
  );

  // eslint-disable-next-line
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    fetchOrganizationDetails(organizationID);
  }, []);

  const organizationName = get(organizationDetails.data, "name", "");

  const goToOrganizationDetailPage = () => {
    history.push(`/organizations/${organizationID}`);
  };

  const renderTable = () => {
    return (
      <EventSubscriptionsTable
        isLoading={EventSubscriptionIndex.status === "loading"}
        data={EventSubscriptionIndex.data ? EventSubscriptionIndex.data.data : []}
      />
    );
  };

  return (
    <div id="fulfillment-role-management-page" className="page-container">
      <div className="org-name-with-add-btn">
        <div className="organization-name" onClick={goToOrganizationDetailPage}>
          {organizationName}
        </div>
      </div>
      <div className="page-title">EVENT SUBSCRIPTIONS</div>
      {renderTable()}
    </div>
  );
};

export default OrganizationEventSubscriptionsPage;
